import { Avatar } from '@immo/ui-kit';
import { mailboxInitials } from '@/lib/email/mailbox-initials';

type MailboxAvatarProps = {
  // The counterpart's display name when known, else null (bare-address rows).
  readonly name?: string | null;
  // The counterpart's email address — the stable colour seed and the initials
  // source when no display name is present.
  readonly email: string | null;
  readonly size?: 'sm' | 'md' | 'lg';
  readonly className?: string;
  readonly title?: string;
};

// The coloured initials circle every mailbox surface leads its rows with (IMM-233
// design): message lists, the conversation view and the settings account row. Wraps
// the ui-kit Avatar with mailbox-aware initials and a per-address colour seed.
export function MailboxAvatar({ name, email, size = 'md', className, title }: MailboxAvatarProps) {
  const label = (name ?? '').trim() !== '' ? (name ?? null) : email;
  const seed = (email ?? name ?? '').toLowerCase();

  return (
    <Avatar
      initials={mailboxInitials(label)}
      seed={seed}
      size={size}
      {...(className !== undefined ? { className } : {})}
      {...(title !== undefined ? { title } : {})}
    />
  );
}
